import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeesApi = {
    getCommittees: (): Observable<Dtos.GetCommitteesResponse> => {
        //Create the request.
        let request: Dtos.GetCommittees = new Dtos.GetCommittees();

        //Send request.
        const response: Promise<Dtos.GetCommitteesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeById: (id: number): Observable<Dtos.GetCommitteeByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeById = new Dtos.GetCommitteeById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommittee: (committee: Dtos.Committee): Observable<Dtos.SetCommitteeResponse> => {

        let request: Dtos.SetCommittee = new Dtos.SetCommittee();

        request.committee = committee;

        // send request
        const response: Promise<Dtos.SetCommitteeResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommittee: (): Observable<Dtos.CreateCommitteeResponse> => {
        //Create the request.
        let request: Dtos.CreateCommittee = new Dtos.CreateCommittee();

        //Send request.
        const response: Promise<Dtos.CreateCommitteeResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommittee: (committee: Dtos.Committee): Observable<Dtos.ValidateCommitteeResponse> => {

        let request: Dtos.ValidateCommittee = new Dtos.ValidateCommittee();

        request.committee = committee;

        // send request
        const response: Promise<Dtos.ValidateCommitteeResponse> = client.post(request);

        return Observable.from(response);
    }
}